import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApModalResult, ApModalService } from 'webcommon/core-ui';
import { FindControlUIBehaviorDto, FindControlUserColumnsConfigDto } from 'webcommon/shared';

import { ApFindControlReorderColumnsModalComponent } from './ap-findcontrol-reorder-columns-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ApFindControlReorderColumnsModalService {
  constructor(
    private apModalService: ApModalService,
  ) {
  }

  openModal(findControlBehavior: FindControlUIBehaviorDto): Observable<ApModalResult<FindControlUserColumnsConfigDto>> {
    const initialState = {
      findControlBehavior,
    };
    const obs = this.apModalService.showComponentModal$(ApFindControlReorderColumnsModalComponent, {
      initialState,
    });
    return obs;
  }
}
